import React from 'react'
import { useStep4Props } from './types'
import { wrap } from '../../../utils/globalUtils'
import Step4View from './views/Step4View'
import useStep4 from './hooks/useStep4'

const Step4: React.FC<useStep4Props> = wrap(Step4View, useStep4)
export default Step4
